import { Outlet, useLocation } from 'react-router';
import Navbar from './Navbar';
import Footer from './Footer';
import ScrollToTop from '../shared/ScrollToTop';
import FloatingCta from '../shared/FloatingCta';
import CookieConsent from '../shared/CookieConsent';
import TeamMemberDrawer from '../about/TeamMemberDrawer';
import { useTeamDrawer } from '../../hooks/useTeamDrawer';
import { dictionary } from '../../dictionary';

const localBusinessJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'LegalService',
  name: dictionary.general.firmName,
  telephone: dictionary.general.phone,
  email: dictionary.general.email,
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'ירושלים',
    addressCountry: 'IL',
  },
  url: 'https://omerzilber.co.il',
};

export default function RootLayout() {
  const { pathname } = useLocation();
  const isHomepage = pathname === '/';
  const hideFloatingCta = isHomepage || pathname === '/contact';
  const { phase, selectedMember, closeDrawer } = useTeamDrawer();

  const isAnimating = phase !== 'closed';
  const isPushed = phase === 'opening' || phase === 'open';

  return (
    <>
      <script type='application/ld+json'>{JSON.stringify(localBusinessJsonLd)}</script>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100dvh',
          transform: isPushed ? 'translateY(-100vh)' : isAnimating ? 'translateY(0)' : 'none',
          transition: isAnimating ? 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)' : 'none',
          willChange: isAnimating ? 'transform' : 'auto',
        }}
      >
        <a
          href='#main-content'
          style={{
            position: 'absolute',
            width: '1px',
            height: '1px',
            padding: 0,
            margin: '-1px',
            overflow: 'hidden',
            clip: 'rect(0, 0, 0, 0)',
            whiteSpace: 'nowrap',
            borderWidth: 0,
          }}
          onFocus={(e) => {
            e.currentTarget.style.position = 'fixed';
            e.currentTarget.style.left = '16px';
            e.currentTarget.style.top = '16px';
            e.currentTarget.style.width = 'auto';
            e.currentTarget.style.height = 'auto';
            e.currentTarget.style.overflow = 'visible';
            e.currentTarget.style.clip = 'auto';
            e.currentTarget.style.whiteSpace = 'normal';
            e.currentTarget.style.margin = '0';
            e.currentTarget.style.zIndex = '9999';
            e.currentTarget.style.padding = '8px 16px';
            e.currentTarget.style.background = '#2C2C2C';
            e.currentTarget.style.color = '#FAFAFA';
            e.currentTarget.style.borderRadius = '4px';
          }}
          onBlur={(e) => {
            e.currentTarget.style.position = 'absolute';
            e.currentTarget.style.width = '1px';
            e.currentTarget.style.height = '1px';
            e.currentTarget.style.overflow = 'hidden';
            e.currentTarget.style.clip = 'rect(0, 0, 0, 0)';
            e.currentTarget.style.whiteSpace = 'nowrap';
            e.currentTarget.style.margin = '-1px';
          }}
        >
          {dictionary.general.aria.skipToContent}
        </a>
        <ScrollToTop />
        <Navbar isHomepage={isHomepage} />
        <main id='main-content' style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <Outlet />
        </main>
        {!isHomepage && <Footer />}
        {!hideFloatingCta && <FloatingCta />}
        <CookieConsent />
      </div>
      <TeamMemberDrawer member={selectedMember} phase={phase} onClose={closeDrawer} />
    </>
  );
}
